<template>
  <div id="configuration">
    <Message :message="message" :type="type" v-if="message !== ''"></Message>
    <Message :message="error.msg" type="error" v-for="error in errors.items"></Message>
    <Message :message="$t('configuration.refresh')" type="warning"></Message>
    <Preloader v-if="!loaded"></Preloader>
    <h2 class="title">{{$t('config-site.title')}}</h2>
    <div class="content" v-if="loaded">
      <div class="controls">
        <div class="buttons">
          <div class="ops">
            <SubmitButton :class="{validation: validation}" @save="saveHandler"></SubmitButton>
            <CancelButton @cancel="cancelHandler"></CancelButton>
          </div>
        </div>
      </div>
      <h4>{{$t('config-site.backendConfig')}}</h4>
      <div class="table-container">
        <div class="table">
                    <span class="tr">
                        <span class="td">{{$t('config-site.key')}}</span>
                        <span class="td">{{$t('config-site.value')}}</span>
                    </span>

          <span :key="key" class="tr" v-for="(value, key) in backendConfig">

                   <span class="td key-lead">
                       <div>
                           <span class="key">{{key}}</span>
                           <span class="default"
                                 v-if="key === 'SHOP_IMAGE_RESOURCE_PATH'">{{$t('general.dimensions')}}</span>
                           <span class="default" v-if="key === 'MAINTANACE_MAILING_LIST'">janusz@example.com,admin@example.com</span>
                           <span class="default" v-if="key === 'TOKEN_DURATION'">{{$t('config-site.token')}} min: 180000 max: 86400000</span>
                       </div>
                   </span>
                   <span class="td">
                       <input type="text" v-if="key === 'TOKEN_DURATION' && role === 'OPTIGUARD'"
                              v-model="backendConfig[key]"
                              v-validate="'required|between:180000,86400000'">
                       <input type="text" v-else
                              v-model="backendConfig[key]" v-validate="'required'"></span>
                    </span>
        </div>
      </div>
      <h4>{{$t('config-site.css')}}</h4>
      <Message :message="error.msg" type="error" v-for="error in errors.items"></Message>
      <div class="table-container">
        <div class="table">
                    <span class="tr">
                        <span class="td">{{$t('config-site.key')}}</span>
                        <span class="td">{{$t('config-site.value')}}</span>
                        <span class="td">{{$t('config-site.preview')}}</span>
                    </span>
          <span :key="key" class="tr" v-for="(value, key) in cssConfig">
                        <span class="td key-lead">
                            <div>
                            <span class="key">{{key}}</span>
                                <span
                                  @click="cssConfig[key].value = cssConfig[key].default"
                                  class="default">{{$t('general.default')}}: {{cssConfig[key].default}}</span>
                        </div>
                        </span>
                   <span class="td">
                       <input :placeholder="cssConfig[key].default" type="text"
                              v-model="cssConfig[key].value"
                              v-validate="{required: true,regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/}">
                   </span>
                        <span :style="`background-color: ${cssConfig[key].value};`"
                              class="td"></span>
                    </span>
        </div>
      </div>
    </div>
    <!--   <h4>{{$t('config-site.helpConfig')}}</h4>
       <CKEditor :editor="editor" v-model="helpPage"></CKEditor>-->
    <div :key="help.id" class="help" v-for="help in helpPages" v-if="role === 'OPTIGUARD'">
      <h4>{{$t('config-site.helpConfig')}} - {{help.id}}</h4>
      <CKEditor :editor="editor" v-model="help.value"></CKEditor>
    </div>

  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import SubmitButton from '@/components/helpers/SubmitButton.vue';
import CancelButton from '@/components/helpers/CancelButton.vue';
import Message from '@/components/helpers/Message.vue';
import Preloader from '@/components/helpers/Preloader.vue';

const ConfigurationRepository = RepositoryFactory.get('configuration');

export default {
  name: 'Configuration',
  components: {
    SubmitButton,
    Message,
    CancelButton,
    Preloader,
    CKEditor: CKEditor.component,
  },
  data() {
    return {
      backendConfig: {},
      cssConfig: {},
      loaded: false,
      message: '',
      type: 'info',
      helpPage: '',
      helpPages: [],
      editor: ClassicEditor,
      langs: '',
      restrictedProps: ['MAINTANACE_MAILING_LIST',
        'MAINTANACE_MAILING_SUBJECTS',
        'SHOP_IMAGE_FORMAT',
        'SHOP_IMAGE_RESOURCE_PATH',
        'TOKEN_DURATION',
      ],
    };
  },
  computed: {
    validation() {
      if (this.errors.items.length > 0) {
        return true;
      }
    },
    role() {
      return this.$store.getters.role;
    },
  },
  methods: {
    inArray(key) {
      return (this.restrictedProps.indexOf(key) > -1);
    },
    async saveHandler() {
      if (this.errors.items.length > 0) {
        return false;
      }
      this.loaded = false;

      const payload = {
        backendConfig: this.backendConfig,
      };
      payload.backendConfig.CONTACT_HTML = JSON.stringify(this.helpPages);
      payload.backendConfig.CSS_FILE = JSON.stringify(this.cssConfig);
      const css = {};
      Object.keys(this.cssConfig).forEach((v, k) => {
        css[v] = this.cssConfig[v].value;
      });
      this.$store.commit('set_css_config', css);
      this.$store.commit('set_backend_config', this.backendConfig);
      try {
        await ConfigurationRepository.saveConfiguration(this.$store.getters.token, payload);
        await this.getCurrentConfig();
        const config = await ConfigurationRepository.getConfiguration(this.$store.getters.token);
        await this.$store.dispatch('setConfig', config);
        this.type = 'info';
        this.message = this.$t('messages.genericSave');
      } catch (error) {
        this.type = 'error';
        this.message = this.$t('errors.genericError');
      }
    },
    cancelHandler() {
      this.loaded = false;
      this.errors.clear();
      this.getCurrentConfig();
      this.message = this.$t('messages.genericCancel');
    },
    getCurrentConfig() {
      this.backendConfig = this.$store.getters.backendConfig;
      const css = {};
      const { cssConfig } = this.$store.getters;
      const { defaultCss } = this.$store.getters;
      Object.keys(cssConfig).forEach((value) => {
        css[value] = { value: cssConfig[value], default: defaultCss[value] };
      });
      this.helpPages = this.$store.getters.htmlContact;
      this.cssConfig = css;
      const langs = this.$i18n.messages;
      const langCodes = Object.keys(langs);
      langCodes.forEach((lang) => {
        if (this.helpPages.filter(language => (language.id === lang)).length > 0) {

        } else {
          this.helpPages.push({ id: lang, value: '' });
        }
      });
      Object.keys(this.backendConfig).forEach((value) => {
        if (this.inArray(value)) {
          if (this.role !== 'OPTIGUARD') {
            delete this.backendConfig[value];
          }
        }
      });
      this.loaded = true;
    },
  },
  mounted() {
    this.$validator.localize(this.$i18n.locale, {
      messages: {
        required: field => this.$t('configuration.validation.required'),
        regex: field => this.$t('configuration.validation.color'),
        between: field => this.$t('configuration.validation.token'),
      },
    });
    this.getCurrentConfig();
  },
};
</script>

<style lang="scss" scoped>
  .validation {
    filter: grayscale(100%);
    cursor: not-allowed !important;
  }

  .key-lead {
    > div {
      display: flex;
      flex-direction: column;
    }

    .key {
      font-weight: bold;
    }

    .default {
      font-size: 10px;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  h4 {
    font-size: rem(18px);
    line-height: rem(40px);
  }

  h2 {
    font-size: rem(30px);
    font-weight: 800;
    text-align: left;
  }

  DIV.table {
    display: table;
    background: white;
    /*box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);*/
    box-shadow: none;
    padding: 46px 36px;
    border-radius: 5px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    border-collapse: separate;
    /* color: #878a94; */
    overflow-x: auto;
    table-layout: fixed;
  }

  FORM.tr, DIV.tr {
    display: table-row;
  }

  span.tr {
    border: none;
    display: table-row;

    &:first-child {
      font-weight: bold;

      > .td {
        border-bottom: 1px solid #005fab;
        padding-bottom: 16px;
        line-height: 18px;
        font-weight: 900;
      }
    }

    > .td {
      border-top: none;
      font-size: rem(14px);
      line-height: 19px;
    }
  }

  SPAN.td {
    display: table-cell;
    border: none;
    text-align: left;
    font-size: rem(15px);


    &:first-child {
      border-left: none;
    }

    &:last-child {
      border-right: none;

    }
  }

  .controls {
    margin-bottom: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @include media('<1450px') {
      flex-wrap: wrap;
    }

    .buttons {
      display: flex;
      @include media('<1450px') {
        width: 100%;
        justify-content: space-between;
      }
      @include media('<470px') {
        flex-direction: column;
      }

      .adds, .ops {
        display: flex;
        justify-content: space-between;
        @include media('<1200px') {
          flex-direction: column;
        }
        @include media('<1025px') {
          flex-direction: row;
          width: 100%;
        }
        @include media('<776px') {
          flex-direction: column;
        }

      }

      .adds {
        @include media('<1200px') {
          align-items: baseline;
          justify-content: center;
        }
        @include media('<776px') {
          align-items: baseline;
          justify-content: center;
        }
      }

      .ops {
        button {
          @include media('<1200px') {
            margin: 5px 0;
          }
        }
      }

    }

    .search-container {
      width: 611px;
      margin-left: 20px;
      @include media('<1450px') {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
      }
    }

    input {
      border: 1px solid #e5e5e5;
      width: 100%;
      box-sizing: border-box;
      padding: 20px 40px;
      border-radius: 5px;
      margin-left: auto;

    }
  }

  input {
    /* color: #878a94; */
    font-size: rem(14px);
    line-height: rem(19px);
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .ops {
    .button-container {
      padding: 0 25px;
    }
  }

  .table-container {
    overflow-x: auto;

    table, .table {
      min-width: 900px;
    }
  }
</style>
